import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'app/api.service';

export interface ApprovalCount {
  total: number;
  byType: { [key: string]: number };
}

@Injectable({
  providedIn: 'root'
})
export class ApprovalCountService {
  private approvalCountSubject = new BehaviorSubject<ApprovalCount>({ total: 0, byType: {} });
  public approvalCount$ = this.approvalCountSubject.asObservable();

  constructor(private apiService: ApiService) {}

  // Get current approval count
  getApprovalCount(): Observable<ApprovalCount> {
    return this.approvalCount$;
  }

  // Get current count value
  getCurrentCount(): ApprovalCount {
    return this.approvalCountSubject.value;
  }

  // Update approval count
  updateApprovalCount(count: ApprovalCount): void {
    this.approvalCountSubject.next(count);
  }

  // Refresh approval count from API
  refreshApprovalCount(): void {
    // Assuming we have the user ID from auth service or similar
    const userId = 1; // Replace with actual user ID
    
    this.apiService.getApprovalsForUser().subscribe(
      (response: any) => {
        if (response.status) {
          // Use the direct approvals_count if available, otherwise calculate from grouped data
          let total = 0;
          const byType: { [key: string]: number } = {};
          
          if (response.approvals_count !== undefined) {
            // Use the direct count from API
            total = response.approvals_count;
          } else if (response.approvals_grouped_by_document_type) {
            // Fallback to calculating from grouped data
            Object.keys(response.approvals_grouped_by_document_type).forEach(key => {
              const count = response.approvals_grouped_by_document_type[key].length;
              total += count;
              byType[key] = count;
            });
          }
          
          const count: ApprovalCount = { total, byType };
          this.updateApprovalCount(count);
        } else {
          this.updateApprovalCount({ total: 0, byType: {} });
        }
      },
      (error) => {
        console.error('Error fetching approval count:', error);
        this.updateApprovalCount({ total: 0, byType: {} });
      }
    );
  }

  // Clear approval count (useful for logout)
  clearApprovalCount(): void {
    this.updateApprovalCount({ total: 0, byType: {} });
  }
}
